module.exports = __webpack_public_path__ + "static/media/photo2.43ff8497.PNG";